"use strict";

const MonitoringLocationFilters = function () {
  const searchFields = ["name"];

  var filterResourceDataHandler = async function (
    unfilteredData,
    filters,
    loadingScreen,
    smartFilters,
  ) {
    const filteredData = ResourceFilters.spatialFilters(unfilteredData, filters);

    return smartFilters ? smartFilters.filter(filteredData, filters) : filteredData;
  };

  var addGeoServerFilterQuery = function (queryStrings, filters) {
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "assetType",
      "asset_type",
    );
    GeoServerFilterFunctions.yesNoExistsGeoServerFilter(
      filters,
      "isMonitoringLocation",
      queryStrings,
      {
        columnName: "monitoring_location_id",
      },
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "cof",
      "cof_final_text",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "flowCondition",
      "flow_condition",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "collectSamples",
      "collect_samples",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "illicitDischarge",
      "illicit_discharge",
    );
    GeoServerFilterFunctions.addFilterToGeoServerQuery(
      queryStrings,
      filters,
      "waterQualityExceedances",
      "water_quality_exceedances",
    );

    if (filters.searchString) {
      queryStrings.push(
        GeoServerFilterFunctions.getSearchQuery(searchFields, filters.searchString),
      );
    }

    GeoServerFilterFunctions.addDateQuery(
      queryStrings,
      "idde_screening_date",
      filters.iddeScreeningDate?.from,
      filters.iddeScreeningDate?.to,
    );
    GeoServerFilterFunctions.addGeographicalFocusFiltersToQuery(filters, queryStrings, [
      { key: "drainsToRw", field: "drains_to_rw" },
      { key: "drainsToC", field: "drains_to_c" },
      { key: "catchmentName", field: "catchment_name" },
    ]);
  };

  var passAssetTypeFilter = function (datum, filters) {
    return (
      !filters.assetType?.length ||
      filters.assetType.includes(CompositeAssetId.parse(datum.id).assetType)
    );
  };

  var passIddeScreeningDateFilter = function (datum, filters) {
    return ResourceFilters.passIsoDateFilter(
      datum.iddeScreeningDate,
      filters.iddeScreeningDate?.from,
      filters.iddeScreeningDate?.to,
    );
  };

  var getFilterConfigs = function () {
    return {
      drainsToRw: "drainsToRw",
      drainsToC: "drainsToC",
      catchmentName: "catchmentName",
      subGroups: "groupId",
      assetType: passAssetTypeFilter,
      isMonitoringLocation: "isMonitoringLocation",
      flowCondition: "flowCondition",
      collectSamples: "collectSamples",
      illicitDischarge: "illicitDischarge",
      waterQualityExceedances: "waterQualityExceedances",
      cof: "cof",
      ...ResourceFilters.getSmartToDoFilters(),
      otherFilters: (datum, filters) => {
        return (
          ResourceFilters.passSearchStringFilter(datum, filters, searchFields) &&
          passIddeScreeningDateFilter(datum, filters)
        );
      },
    };
  };

  return {
    filterResourceDataHandler,
    addGeoServerFilterQuery,
    getFilterConfigs,
    passAssetTypeFilter,
  };
};

module.exports = MonitoringLocationFilters();

const CompositeAssetId = require("../general/compositeAssetId");
const ResourceFilters = require("../filters/resourceFilters");
const GeoServerFilterFunctions = require("../mapFunctions/geoServerFilterFunctions");
